import { eventGet as _eventGet } from '@/projects/kiss/utils/reportInfo/reportedMethods'
import { IClickGet } from '@/projects/kiss/utils/reportInfo/types'
import {
  getCookie,
  getLocationVars,
  isFBWeb,
  getUA,
  copy,
  getRatio,
  removeEmptyOrNullProperties,
  converUrlParamsObj
} from '@/utils/utils'
import webview from '@/utils/web-view'

/** kiss商店链接 */
const downLoadUrlDic = {
  googlePlay:
    'https://play.google.com/store/apps/details?id=com.stardust.kissreader',
  appStore: 'https://apps.apple.com/app/id1508942129'
}

// 落地页3.5上报
export const eventGet = (param: Partial<IClickGet>) => {
  console.log('🚀 ~ file: buried-point.ts ~ line 8 ~ eventGet ~ param', param)
  const _param = {
    eid: 13,
    parm5: 'h5_af_link_stat',
    ...param
  }
  return _eventGet(_param)
}

/** 获取页面滚动进度 */
export const scrollProgress = (): number => {
  const scrollTop =
    document.documentElement.scrollTop || document.body.scrollTop
  const scrollHeight =
    document.documentElement.scrollHeight || document.body.scrollHeight
  const clientHeight =
    document.documentElement.clientHeight || window.innerHeight
  const progress = Math.round((scrollTop / (scrollHeight - clientHeight)) * 100)
  return progress
}

/** 落地页点击下载
 * @returns  返回自研匹配上报信息
 */
export const booksAdvClickHandle = ({
  urlQueryParams,
  uidNum
}: {
  urlQueryParams: any
  uidNum: string
}): any => {
  // id - 表示后台配置的引流H5对应的id
  // mode - 1-静态按钮 2-动态按钮 3-闪屏 6-Passion落地页
  // mediaType - 引流媒体 （rs-reelshort tt-TikTok fb-Facebook rs_campaign-kiss引流活动）
  const {
    id,
    mode = '1',
    mediaType = 'fb',
    ttclid = '',
    gclid = '',
    gbraid = '',
    wbraid = '',
    px = ''
  } = getLocationVars()
  const copyJSONStr = JSON.stringify(urlQueryParams)
  // 点击Continue Reading上报

  copy(copyJSONStr)

  return {
    visitorId: uidNum,
    href: urlQueryParams.href || location.href,
    referrer: document?.referrer,
    goto: JSON.stringify(urlQueryParams),
    arg: {
      pixelid: px,
      // fb
      _fbc: getCookie('_fbc'),
      _fbp: getCookie('_fbp'),
      // tt
      ttclid,
      ttp: getCookie('_ttp'),
      // gg
      gclid,
      gbraid,
      wbraid
    },
    did: {
      w: Math.floor((window.screen.width * getRatio()) / 100),
      h: Math.floor((window.screen.height * getRatio()) / 100)
    },
    ua: navigator.userAgent
  }
}

/** 生成onelink长链接 */
export const generateOneLink = ({
  mediaType = 'fb',
  urlQueryParams
}: {
  mediaType: string
  urlQueryParams: any
}): string => {
  // format对应后台的内容类型：1-书籍；6-视频
  const { af_ios_url = '', af_android_url = '' } = getLocationVars()
  const { contentType = 1, returnType = 0 } = urlQueryParams
  let link = ''
  // 1-app跳转大厅，2-app跳转阅读器
  const pushType = !urlQueryParams?.bookId || !urlQueryParams?.chapterId ? 1 : 2
  // 1001-阅读页 1000-大厅（前端自定义的）
  const type =
    !urlQueryParams?.bookId || !urlQueryParams?.chapterId ? 1000 : 1001

  const commonObj: Record<string, any> = {
    af_ios_url
  }

  const { android } = getUA()
  // 如果传了安卓备用链接，就作为onelink的fallback链接使用
  if (af_android_url && android) {
    commonObj['af_android_url'] = af_android_url
  }

  removeEmptyOrNullProperties(commonObj)
  const commonParms = converUrlParamsObj(commonObj)

  const af_dp = `&af_dp=${encodeURIComponent(
    `cmskiss://?formType=${
      mediaType?.includes('rs') ? 2 : 1
    }&type=${type}&parm1=${
      urlQueryParams?.bookId || ''
    }&pushType=${pushType}&contentType=${contentType}&returnType=${returnType}&chapterId=${
      urlQueryParams?.chapterId || ''
    }&deep_link_sub1=23`
  )}`
  const deeplink = `https://kissapp.onelink.me/6Vxq?af_xp=social&pid=web2app&c=web-to-app&af_sub1=89757&af_sub2=678910&deep_link_value=${encodeURIComponent(
    `cmskiss://?formType=${
      mediaType?.includes('rs') ? 2 : 1
    }&type=${type}&parm1=${
      urlQueryParams?.bookId || ''
    }&pushType=${pushType}&contentType=${contentType}&returnType=${returnType}&chapterId=${
      urlQueryParams?.chapterId || ''
    }&deep_link_sub1=23`
  )}${commonParms ? '&' + commonParms : ''}`
  link = deeplink + af_dp
  console.log(
    '%c [ link ]-110',
    'font-size:13px; background:pink; color:#bf2c9f;',
    link
  )

  return link
}

/** 跳转onelink
 * @param urlQueryParams 跳转参数
 * @param toGooglePlay 是否直接跳转到google play
 */
export const toAppLink = ({
  urlQueryParams,
  toGooglePlay = true
}: {
  urlQueryParams: any
  toGooglePlay?: boolean
}): void => {
  const { mediaType = 'fb', af_android_url = '' } = getLocationVars()
  const { ios } = getUA()
  // ！之后添加rs引流类型需要注意
  if (mediaType?.includes('rs') && (window?.Android || window?.webkit)) {
    webview.exec('toOneLink', {
      parameter: [['onelink', generateOneLink({ mediaType, urlQueryParams })]]
    })
  } else {
    let link = generateOneLink({
      mediaType,
      urlQueryParams
    })
    if (toGooglePlay && !ios) {
      link = af_android_url
        ? af_android_url
        : `https://play.app.goo.gl/?link=${downLoadUrlDic.googlePlay}`
    }
    // 定时跳转
    setTimeout(() => {
      console.log(
        '%c [ 定时跳转 ]-156',
        'font-size:13px; background:pink; color:#bf2c9f;',
        link
      )
      window.location.href = link
    }, 500)
  }
}

/** kiss落地页域名pixel映射 */
const pixelMap: {
  hostname: string
  fb: string
  tt: string
  pixel: string
  [key: string]: string
}[] = [
  {
    hostname: 'stardust-h5.stardustgod.com',
    fb: '1189113388588817',
    tt: 'CJ49M9BC77U1K8LNGRDG',
    pixel: ''
  },
  {
    hostname: 'pakchois.com',
    fb: '1485453421926247',
    tt: 'CJ49M9BC77U1K8LNGRDG',
    pixel: ''
  },
  {
    hostname: 'stardust-publish.com',
    fb: '820118595715063',
    tt: 'CJ49MTBC77U3DHQFNNGG',
    pixel: ''
  },
  {
    hostname: 'stardusttime.com',
    fb: '561066732625690',
    tt: 'CJ49MTBC77U3DHQFNNGG',
    pixel: ''
  }
]

/** 获取对应域名下的配置 */
export const getDomainConfig = (): { pixel: string } => {
  const { px = '', mediaType = 'fb' } = getLocationVars()
  const hostname = location.hostname
  // 没匹配上取kiss原来的配置
  const config =
    pixelMap.find((item) => item.hostname === hostname) || pixelMap[0]
  // 如果地址栏有px就使用传入的
  config.pixel = px ? decodeURIComponent(px) : config?.[mediaType] || ''
  return config
}
